@if (model()) {
  <div class="mt-4">
    <app-customer-form [customer]="model()!" (formGroupOutput)="formGroup = $event"></app-customer-form>
  </div>
  @if (formGroup) {
    <div class="d-flex justify-content-end align-items-center mt-4">
      <app-mdb-button (onClick)="submit()" [loading]="loading" [text]="'SAVE'"></app-mdb-button>
    </div>
  }
}
